var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Stepper',{attrs:{"steps":_vm.steps}})
}
var staticRenderFns = []

export { render, staticRenderFns }